import { AddGeofenceComponent } from "./add-geofence/add-geofence.component";
import { EditGeofenceComponent } from "./edit-geofence/edit-geofence.component";
import { ViewGeofenceComponent } from "./view-geofence/view-geofence.component"

export const GeofenceRouting: any = [
    { path: '', redirectTo: 'view-geofence', pathMatch: 'full' },
    { path: 'add-geofence', component: AddGeofenceComponent },
    { path: 'view-geofence', component: ViewGeofenceComponent },
    { path: 'edit-geofence/:geofenceID', component: EditGeofenceComponent },
    { path: 'preview-geofence/:geofenceID/:view', component: EditGeofenceComponent },

];

export const GeofenceRoutingBreadcrumbs = [
    { name: 'Edit', path: '/edit-geofence' },
    { name: 'Add', path: '/add-geofence' },

];